import { Productrequest } from "./productrequest";

export class PrecizionRequest {
    FarmIds: string[];
    CampaignId: number = -1;
    PlotIds: string[];
    PreconisationIds: string[];
    //si sur le modele Standard correspond a l id du model, si console perso son UID
    ConsoleId: string= "";
    //Id du modele de la console indique le format de l export
    ModelId: string = "";

    //true on est sur un export vers une console connecté compte lié agPrecision
    IsConnectedDevice :boolean = false;
    //device manufacturer
    DeviceManufacturer :string = "";

      /**
     *Filtre sur la selection Ancien traitement OrderByPlots
     * Plot=0, Cultivation=1
     */
    FilterSelected:number = -1;
    Products :Productrequest[];
    /**
     * Indique qu il merge les Plot.precos - inter-ou modulation
     */
    blMergePrecos:boolean;

    /**
     * Indique qu il merge les Plot.precos - inter-ou modulation
     * QUE pour les même culture (true), si false pas de same culture
     */
    blMergePlotSameCulture:boolean;

    /**Taille du buffer d'�largissement de plots */
    BufferSize:number=0;

    /**indique que l'on exclue les preconisations parcelles avec un lien avec la prévis liée exportée */
    ExcludePrecosOnPrevis : boolean=false;

    /**
     *this is to initialize the three list objects to avoid errors when given values.
     */
    constructor() {
        this.FarmIds = [];
        this.PlotIds = [];
        this.PreconisationIds = [];
        this.Products=[];
        this.blMergePrecos=false;
        this.blMergePlotSameCulture = true;
        this.BufferSize=0;
        this.ExcludePrecosOnPrevis=false;
    }
}